<template>
  <NavigationForm action="edit" :navigation="navigation" :pages="pages"/>
</template>

<script>
import NavigationForm from '@/components/Navigation/NavigationForm'
import Page from '@/model/Page'
import * as types from '@/store/types.js'

export default {
  components: {
    NavigationForm
  },
  computed: {
    navigation () {
      this.$store.dispatch(types.ACTIVE_NAVIGATION)
      return this.$store.getters[types.ACTIVE_NAVIGATION]
    }
  },
  data () {
    return {
      pages: []
    }
  },
  beforeRouteEnter (to, from, next) {
    axios.all([
      Page.index({all_languages: true, allPages: true, order_by: 'title', sort_by: 'asc'})
    ]).then(axios.spread((pages) => {
      next(vm => {
        vm.pages = pages.data.data
      })
    }))
  }
}
</script>



// WEBPACK FOOTER //
// src/views/navigation/Edit.vue